import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5d3150d9&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3150d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d3150d9')) {
      api.createRecord('5d3150d9', component.options)
    } else {
      api.reload('5d3150d9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5d3150d9&scoped=true", function () {
      api.rerender('5d3150d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Thumb/index.vue"
export default component.exports